"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppSwitcherEntity = exports.ExternalAppSource = void 0;
var ExternalAppSource;
(function (ExternalAppSource) {
    ExternalAppSource["ADA"] = "ADA";
    ExternalAppSource["CASSI"] = "CASSI";
    ExternalAppSource["COMMUNITY"] = "Community";
    ExternalAppSource["DIRECTORY"] = "Directory";
    ExternalAppSource["GOVERNATOR"] = "Governator";
    ExternalAppSource["TRFIND"] = "TRFind";
})(ExternalAppSource = exports.ExternalAppSource || (exports.ExternalAppSource = {}));
var AppSwitcherEntity;
(function (AppSwitcherEntity) {
    AppSwitcherEntity["CONTACT"] = "contact";
    AppSwitcherEntity["CLOUD_SITE"] = "cloud-site";
    AppSwitcherEntity["SERVER"] = "server";
    AppSwitcherEntity["ENTITLEMENT"] = "entitlement";
    AppSwitcherEntity["ATLASSIAN_ACCESS"] = "atlassian-access";
})(AppSwitcherEntity = exports.AppSwitcherEntity || (exports.AppSwitcherEntity = {}));
